import React, { useState } from "react";
import { Radio, Library, Pencil, Check, LogIn, LogOut, User as UserIcon, Crown, Settings, Share2 } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function TopNav() {
  const { setShowCollection, collection, freeAccess, editMode, setEditMode, user, setAuthOpen, setAccountOpen, setShareOpen, logout, canEdit } = useApp();
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/55 border-b border-white/5">
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center pl-1 select-none">
          <img src="/brand/s71-logo-sm.png" alt="S71" className="h-7 w-auto object-contain" draggable="false" />
        </div>

        <div className="flex items-center gap-1.5">
          <button className="flex items-center gap-1.5 px-3 h-8 rounded-full text-[12px] text-white/70 hover:text-white hover:bg-white/5 transition-colors">
            <Radio size={15} />
            <span className="hidden xs:inline">Radio</span>
          </button>

          <button
            onClick={() => setShowCollection(true)}
            className="relative flex items-center gap-1.5 px-3 h-8 rounded-full text-[12px] bg-white/10 text-white hover:bg-white/15 transition-colors"
          >
            <Library size={15} />
            <span className="hidden xs:inline">Collection</span>
            {!freeAccess && collection.length > 0 && (
              <span className="ml-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#8b5cf6] text-[10px] font-semibold flex items-center justify-center">
                {collection.length}
              </span>
            )}
          </button>

          <button
            onClick={() => setShareOpen(true)}
            title="Share / promote your portal"
            className="flex items-center justify-center w-8 h-8 rounded-full text-white/70 hover:text-white hover:bg-white/5 transition-colors"
          >
            <Share2 size={15} />
          </button>

          {canEdit && (
            <button
              onClick={() => setEditMode((v) => !v)}
              title={editMode ? "Done editing" : "Edit artist"}
              className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors ${
                editMode ? "bg-[#8b5cf6] text-white" : "text-white/70 hover:text-white hover:bg-white/5"
              }`}
            >
              {editMode ? <Check size={15} /> : <Pencil size={15} />}
            </button>
          )}

          {user ? (
            <div className="relative">
              <button
                onClick={() => setMenu((v) => !v)}
                className="flex items-center justify-center w-8 h-8 rounded-full bg-[#8b5cf6]/20 text-[#c4b1ff] hover:bg-[#8b5cf6]/30 transition-colors"
              >
                {user.is_free_access ? <Crown size={15} /> : <UserIcon size={15} />}
              </button>
              {menu && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setMenu(false)} />
                  <div className="absolute right-0 mt-2 w-52 rounded-xl bg-[#161618] border border-white/10 shadow-2xl z-20 p-1.5">
                    <div className="px-3 py-2">
                      <p className="text-[13px] font-medium text-white truncate">{user.name}</p>
                      <p className="text-[11px] text-white/45 truncate">{user.email}</p>
                      {user.is_free_access && (
                        <span className="inline-flex items-center gap-1 mt-1.5 text-[10px] text-amber-300 bg-amber-400/10 px-2 py-0.5 rounded-full">
                          <Crown size={10} /> Full Access
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => { setMenu(false); setAccountOpen(true); }}
                      className="w-full flex items-center gap-2 px-3 h-9 rounded-lg text-[13px] text-white/70 hover:bg-white/5"
                    >
                      <Settings size={14} /> Account settings
                    </button>
                    <button
                      onClick={() => { setMenu(false); logout(); }}
                      className="w-full flex items-center gap-2 px-3 h-9 rounded-lg text-[13px] text-white/70 hover:bg-white/5"
                    >
                      <LogOut size={14} /> Sign out
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <button
              onClick={() => setAuthOpen(true)}
              className="flex items-center gap-1.5 px-3 h-8 rounded-full text-[12px] bg-[#8b5cf6] text-white hover:bg-[#7c4ef0] transition-colors"
            >
              <LogIn size={14} /> Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
